import { render, staticRenderFns } from "./MissingReportsList.vue?vue&type=template&id=2349e3d7&"
import script from "./MissingReportsList.vue?vue&type=script&lang=js&"
export * from "./MissingReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports